const BASE_KB_URL = 'https://knowledge.hubspot.com/';
const BASE_ACADEMY_URL = 'https://academy.hubspot.com/';
export const resourceUrlsMap = {
  'calling-free-account-upgrade': {
    knowledgeBase: `${BASE_KB_URL}calling/use-the-calling-tool`,
    academy: `${BASE_ACADEMY_URL}lessons/calling-at-the-right-time`
  },
  'livemessages-routing': {
    knowledgeBase: `${BASE_KB_URL}conversations/set-your-conversations-routing-rules#automatically-assign-conversations`
  },
  'tasks-start-queue-new': {
    knowledgeBase: `${BASE_KB_URL}tasks/use-task-queues`,
    academy: `${BASE_ACADEMY_URL}lessons/identifying-good-fit-leads-in-hubspot-part-2`
  },
  'email-automated-sends': {
    knowledgeBase: `${BASE_KB_URL}email/use-automation-with-marketing-emails`,
    academy: `${BASE_ACADEMY_URL}courses/automation-strategy`
  },
  'meetings-settings-namespace-row': {
    knowledgeBase: `${BASE_KB_URL}meetings-tool/create-and-edit-scheduling-pages`,
    academy: `${BASE_ACADEMY_URL}lessons/streamlining-your-outreach-with-meetings`
  }
};